import {
  RIVER,
} from 'actions/river';
import {reducerPackage} from "../../utils";

export const river = reducerPackage(RIVER);
